import { useEffect } from 'react';
import { useParams } from 'react-router-dom';

// MusicBFF の招待着地ページは React ではなく public/bff.html（自己完結の静的 HTML）。
// Sway の index.html を共有していると Smart App Banner / App Clip カードと
// Sway のアイコン・タイトルが MusicBFF のページに出てしまうため、殻ごと分けてある。
//
// 通常 /bff/* はこの SPA まで届かない（public/_redirects と server.js が bff.html を返す）。
// ここに来るのは配信側のルーティングが効いていないときだけ。この保険が無いと
// App.tsx の /:userNumber/:invitationCode が拾って Sway の招待ページに化ける。
export default function BffRedirect() {
  const params = useParams();

  useEffect(() => {
    const code = params['*'] || '';
    const search = new URLSearchParams(window.location.search);
    if (code) search.set('c', code);
    // bff.html は ?c= からもコードを読めるので、パスが落ちても着地する。
    window.location.replace(`/bff.html?${search.toString()}`);
  }, [params]);

  return null;
}
